import {
    Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter,
    ComponentFactoryResolver, ViewContainerRef, OnChanges
} from "@angular/core";
import { TitrationsplanPpopupComponent } from './titrationsplan-popup';
import { SharedService } from '../../shared';
import { Titrationsplan, PartnerNamesEnum } from '../shared';

declare var jsPanel: any;

@Component({
    selector: 'app-titrationsplan',
    templateUrl: "./titrationsplan.component.html",
    styleUrls: ["./titrationsplan.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationsplanComponent implements OnInit, OnChanges {
    @Input() partnerName: string = "";

    @Input() titrationsplan: Titrationsplan;
    @Output() onUpdateData = new EventEmitter<any>();

    PartnerNamesEnum = PartnerNamesEnum;

    jsPanelPopup: any;


    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    get jsPanelContentHeight() {
        return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
    }

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {

    }

    ngOnChanges() {

    }

    openTitrationsPlanPopup() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(TitrationsplanPpopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.titrationsplan = this.titrationsplan;
        componentRef.instance.onSelectValues.subscribe(val => {
            this.onUpdateData.emit(val);
        });
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            //footerToolbar: [
            //    '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
            //    '<button type="button" class="btn btn-sm btn-success" data-type="print">Drucken</button>'
            //],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Titrations Plan',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
                componentRef.instance.fnUpdatePopupContent();
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                    componentRef.instance.fnUpdatePopupContent();
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "print":
                                var html = componentRef.instance.printableHTML;
                                component.sharedService.printHTMLData(html, {
                                    headCss: true
                                });
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }
}
